import React, { useEffect } from 'react'
import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { adminCompanyReportGeneration } from './actions/admin_company_report_generation'
import { Tooltip } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'

export const GeneratedReportDownload = ({generated_report_id, label}) => {
  const dispatch = useDispatch()
  const is_loading = generated_report_id && adminCompanyReportGeneration.isLoading()
  const report = useSelector(() => adminCompanyReportGeneration.getObject(generated_report_id))

  useEffect(() => {
      dispatch(adminCompanyReportGeneration.ensureObjectLoaded(generated_report_id))
  }, [generated_report_id])

  return (
    <>
    { generated_report_id && report ?
      <Tooltip arrow title={`Download ${get(report, ["report_file_info", "original_filename"])}`}>
        <a href={get(report, ["report_file_info", "original_download_url"])}>
          { label ? label : <GetAppIcon fontSize="large" /> }
        </a>
      </Tooltip> :
      "---"
    }
    </>
  )

}
